import Button from "@/common/components/Button";
import Modal from "@/common/components/Modal";
import { useState } from "react";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { useQueryClient } from "@tanstack/react-query";
import useBillingFiscalDocumentGroupConfirmFiscalDocument from "../../hooks/useBillingFiscalDocumentGroupConfirmFiscalDocument";

const ConfirmFiscalDocument = ({ groupId }: { groupId: string; }) => {
  const queryClient = useQueryClient();

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [messages, setMessages] = useState<string[] | boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const { mutate: confirmFiscalDocument } = useBillingFiscalDocumentGroupConfirmFiscalDocument({
    id: groupId,
    onSuccess: () => {
      setModalIsOpen(false);
      setIsError(false);
      setMessages(["Nota confirmada com sucesso!"]);
    },
    onError: (error) => {
      if (error.response?.data.errors.base) {
        setModalIsOpen(false);
        setIsError(true);
        setMessages(error.response?.data.errors.base);
      }
    }
  });

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        setIsOpen={setModalIsOpen}
        Trigger={(
          <Button>Confirmar nota fiscal</Button>
        )}
        title="Você tem certeza?"
        subtitle="Essa nota fiscal será aprovada."
        useCancellableFooter
        showClose={false}
        confirmButtonClassName="bg-primary-blue"
        onConfirm={() => confirmFiscalDocument()}
      />

      {messages && (
        <ModalMessageSimple
          messages={messages}
          setMessages={setMessages}
          isError={isError}
          onClose={() => {
            queryClient.invalidateQueries({ queryKey: ['billingFiscalDocumentGroup', groupId] });
            queryClient.invalidateQueries({ queryKey: ['billingFiscalDocumentGroups'] });
          }}
        />
      )}
    </>
  );
};

export default ConfirmFiscalDocument;
